import { NavigationDropdown } from "@components/general/NavigationDropdown/NavigationDropdown";
import { useUser } from "@hooks/useUser";
import { useWorkspaceContext } from "@state/workspaceContext";
import classNames from "classnames";
import { useMemo } from "react";
import styles from "@components/general/NavigationDropdown/NavigationDropdown.module.scss";
import { WorkspaceSwitcherItem } from "@components/general/NavigationDropdown/WorkspaceSwitcherItem";
import { useSettings } from "@components/settings/SettingsProvider";
import { useSwitchToPersonalView } from "@hooks/useSwitchToPersonalView";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { useWorkspaces } from "@hooks/useWorkspaces";
import { Dropdown } from "react-bootstrap";
import { DefaultNavigationDropdownToggle } from "./DefaultNavigationDropdownToggle";

export const DefaultNavigationDropdown = () => {
    const { activeWorkspace } = useWorkspaceContext();
    const user = useUser();

    const userRoleInWorkspace = useMemo(() => {
        if (!activeWorkspace) {
            return "Member";
        }
        return activeWorkspace.primaryAdminUserId === user.id
            ? "Owner"
            : "Member";
    }, [activeWorkspace, user]);

    const { personalView: personalViewEnabled } = useTypedFlags();
    const goToPersonalView = useSwitchToPersonalView();

    const { open: openSettings } = useSettings();

    const userWorkspaces = useWorkspaces();

    const hasMultipleWorkspaces = (userWorkspaces.data?.length ?? 0) > 1;

    return (
        <NavigationDropdown
            toggle={DefaultNavigationDropdownToggle}
            header={
                <>
                    <div
                        className={classNames(
                            styles.navigationDropdownItemTextOnly,
                            styles.navigationDropdownWorkspaceName,
                        )}
                        data-testid="dropdown-workspace-name"
                    >
                        {activeWorkspace?.name ?? ""}
                    </div>
                    <div
                        className={classNames(
                            styles.navigationDropdownItemTextOnly,
                            styles.navigationDropdownUserEmail,
                        )}
                        data-testid="user-email"
                    >
                        {user.email}
                    </div>
                    <div
                        className={classNames(
                            styles.navigationDropdownItemTextOnly,
                            styles.navigationDropdownUserRoleItem,
                        )}
                    >
                        <span
                            className={styles.navigationDropdownUserRole}
                            data-testid="user-role"
                        >
                            {userRoleInWorkspace}
                        </span>
                    </div>
                </>
            }
        >
            <Dropdown.Item
                onClick={() => openSettings()}
                data-testid="settings-button"
            >
                Settings
            </Dropdown.Item>
            <Dropdown.Divider />
            {hasMultipleWorkspaces && (
                <WorkspaceSwitcherItem disabled={userWorkspaces.isLoading} />
            )}

            {hasMultipleWorkspaces && personalViewEnabled && (
                <Dropdown.Item onClick={goToPersonalView}>
                    View all workspaces
                </Dropdown.Item>
            )}
        </NavigationDropdown>
    );
};
